import { Injectable } from '@angular/core'

import { map } from 'rxjs'

import { MaaBaseService, MaaErikoiskoodit } from '@lemon/core-firebase/service/maa.service-base'
import { LemonTranslationService } from './lemon-translation.service'

import { TuettuKieli } from '@lemon/core/model/common'
import { alpha2ToAlpha3, getNames, registerLocale } from 'i18n-iso-countries'

import enData from 'i18n-iso-countries/langs/en.json' // with { type: 'json' } // requires esnext
import fiData from 'i18n-iso-countries/langs/fi.json' // with { type: 'json' } // requires esnext

registerLocale(fiData)
registerLocale(enData)

export interface Maa {
  koodi: string
  nimi: string
}

@Injectable()
export class MaaService extends MaaBaseService {
  kaikkiMaatJaVeroalueetObservable = this.translationService.currentLanguageObservable.pipe(
    map(kieli => {
      return kieli ? this._annaMaatJaVeroalueet(kieli) : []
    }),
  )

  kaikkiMaatObservable = this.translationService.currentLanguageObservable.pipe(
    map(kieli => {
      return kieli ? this._annaMaat(kieli) : []
    }),
  )

  constructor(private translationService: LemonTranslationService) {
    super()
  }

  private _annaMaatJaVeroalueet(kieli: TuettuKieli): Maa[] {
    const kaikkiMaat = this._annaMaat(kieli)

    for (const maa of kaikkiMaat) {
      if ('GBR' === maa.koodi) {
        maa.nimi = kieli === 'en' ? 'United Kindom (Not Goods to Northern Ireland)' : 'Yhdistynyt Kuningaskunta (Ei Tavaramyynti Pohjois-Irlantiin)'
      } else if ('ESP' === maa.koodi) {
        maa.nimi = kieli === 'en' ? 'Spain (Not Canary Islands)' : 'Espanja (Ei Kanariansaaret)'
      }
    }

    const kanariansaaretNimi = kieli === 'en' ? 'Canary Islands, Spain' : 'Kanariansaaret, Espanja'
    const kanariansaaret: Maa = { koodi: MaaErikoiskoodit.KANARIANSAARET_KOODI_ALPHA_3, nimi: kanariansaaretNimi }
    kaikkiMaat.push(kanariansaaret)

    const pohjoisIrlantiNimi = kieli === 'en' ? 'Northern Ireland, United Kindom' : 'Pohjois-Irlanti, Yhdistynyt Kuningaskunta'
    const pohjoisIrlanti: Maa = { koodi: MaaErikoiskoodit.POHJOIS_IRLANTI_KOODI_ALPHA_3, nimi: pohjoisIrlantiNimi }
    kaikkiMaat.push(pohjoisIrlanti)

    kaikkiMaat.sort((a: Maa, b: Maa) => {
      if (a.nimi > b.nimi) {
        return 1
      }
      if (a.nimi < b.nimi) {
        return -1
      }
      return 0
    })

    return kaikkiMaat
  }

  private _annaMaat(kieli: TuettuKieli): Maa[] {
    const kaannokset = getNames(kieli) ?? []
    const kaikkiMaat: Maa[] = []
    for (const kaannos in kaannokset) {
      if (kaannokset.hasOwnProperty(kaannos)) {
        const koodi = alpha2ToAlpha3(kaannos)
        const nimet = kaannokset[kaannos]
        if (nimet) {
          if (Array.isArray(nimet) && nimet.length > 0) {
            kaikkiMaat.push({ koodi: koodi, nimi: nimet[0] })
          } else if (typeof nimet === 'string') {
            kaikkiMaat.push({ koodi: koodi, nimi: nimet as string })
          } else if ((nimet as any) instanceof String) {
            // The type says string, but as it's third party lib -> safe guard if they lie.
            kaikkiMaat.push({ koodi: koodi, nimi: (nimet as any).toString() })
          }
        }
      }
    }

    kaikkiMaat.sort((a: Maa, b: Maa) => {
      if (a.nimi > b.nimi) {
        return 1
      }
      if (a.nimi < b.nimi) {
        return -1
      }
      return 0
    })

    return kaikkiMaat
  }
}
